/* src/app/features/player/components/player-similar-content/player-similar-content.component.scss */
.similar-content-container .similar-content-header {
  margin-bottom: 50px;
  font-size: 36px;
}
.similar-content-container .mini-similar-content-header {
  margin-bottom: 25px;
}
.similar-content-container .mini-similar-content-title {
  font-size: 18px;
}
.similar-content-container .similar-content-close {
  position: absolute;
  right: 0;
}
.similar-content-container .mini-similar-content-close {
  width: 30px;
  right: 30px;
}
.similar-content-container.translated {
  transform: translateY(50px);
}
.similar-content-container .card {
  background-color: unset;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: transform 0.2s ease;
}
.similar-content-container .card .shadow {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 50%;
  opacity: 1;
  transition: opacity 0.5s ease-in-out;
  background:
    linear-gradient(
      to bottom,
      transparent,
      var(--background_primary));
}
.similar-content-container .similar-content-tile {
  max-width: calc((100% - 3rem) / 3);
}
.similar-content-container .mini-similar-content-row {
  gap: 12px;
}
.similar-content-container .mini-similar-content-row .similar-content-tile {
  max-width: calc((100% - 24px) / 3);
}
.similar-content-container .card-title {
  position: absolute;
  font-size: 16px;
  font-weight: bold;
  color: white;
  bottom: 20px;
  left: 16px;
  right: 16px;
  padding: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.similar-content-container .mini-similar-content-card-title {
  font-size: 14px;
  bottom: 0px;
  left: 8px;
  right: 8px;
  -webkit-line-clamp: 1;
  line-clamp: 1;
}
.mini-player-similar-content {
  bottom: 15px;
}
/*# sourceMappingURL=player-similar-content.component.css.map */
